import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from './logger.service';
import { BillPaymentPackageTotalAmountComponent } from 'src/app/components/bill-payment-package-total-amount/bill-payment-package-total-amount.component';

var TAG = "BillPayPayment_Package_totalAmountService";

@Injectable({
    providedIn: 'root'
})
export class BillPayPayment_Package_totalAmountService {

    constructor(private log: LoggerService,
        private modalService: NgbModal,
    ) { }

    openDialog(patientID: string, invoiceID: string, orgArAmount: number, isChangePay?:boolean, invoiceChangeID?:string) {
        this.log.i(TAG, 'open Dialog');
        const modalRef = this.modalService.open(BillPaymentPackageTotalAmountComponent, { size: 'lg', centered: true, backdrop: 'static' });

        // modalRef.componentInstance.dataList = dataList;
        // modalRef.componentInstance.dataList_Payment = dataList_Payment;
        modalRef.componentInstance.patientID = patientID;
        modalRef.componentInstance.invoiceID = invoiceID;
        modalRef.componentInstance.orgArAmount = orgArAmount;
        modalRef.componentInstance.isChangePay = isChangePay;
        modalRef.componentInstance.invoiceChangeID = invoiceChangeID;
        console.log('isChangePay = '+isChangePay);
        console.log('invoiceChangeID = '+invoiceChangeID);
        return modalRef;

    }



}
